module.exports = __webpack_public_path__ + "media/images/vp/parallax.temp.01-49c525f67a7460a5f0f4903832807764.svg";